import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccessComponent } from './components/access/access.component';
import { SigninComponent } from './pages/signin/signin.component';
import { DashComponent } from './components/dash/dash.component';
import { HomeComponent } from './pages/home/home.component';

import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { SidemenusComponent } from './components/sidemenus/sidemenus.component';
import { HomeMainComponent } from './components/home-main/home-main.component';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { RightSidebarComponent } from './components/right-sidebar/right-sidebar.component';
import { NewContractComponent } from './components/new-contract/new-contract.component';
import { CreateContractComponent } from './pages/create-contract/create-contract.component';
import { AuthInterceptorProvider } from './interceptors/auth.interceptor';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { ContractsComponent } from './pages/contracts/contracts.component';
import { ViewContractComponent } from './components/view-contract/view-contract.component';
import { AppLayoutComponent } from './components/layout/app-layout/app-layout.component';
import { CreateEmployeeComponent } from './pages/create-employee/create-employee.component';
import { NewEmployeeComponent } from './components/new-employee/new-employee.component';
import { NewSkillComponent } from './components/new-skill/new-skill.component';
import { CreateSkillComponent } from './pages/create-skill/create-skill.component';
import { NewVendorComponent } from './components/new-vendor/new-vendor.component';
import { CreateVendorComponent } from './pages/create-vendor/create-vendor.component';
import { ViewSkillComponent } from './components/view-skill/view-skill.component';
import { SkillsComponent } from './pages/skills/skills.component';
import { ViewVendorComponent } from './components/view-vendor/view-vendor.component';
import { VendorsComponent } from './pages/vendor/vendors.component';
import { NewCostCenterComponent } from './components/new-costcenter/new-costcenter.component';
import { CreateCostCenterComponent } from './pages/create-costcenter/create-costcenter.component';
import { CostCentersComponent } from './pages/costcenters/costcenters.component';
import { ViewCostCenterComponent } from './components/view-costcenter/view-costcenter.component';
import { NewLocationComponent } from './components/new-location/new-location.component';
import { CreateLocationComponent } from './pages/create-location/create-location.component';
import { ViewLocationComponent } from './components/view-location/view-location.component';
import { LocationsComponent } from './pages/locations/locations.component';
import { ViewApproveContractComponent } from './components/view-approvecontract/view-approvecontract.component';
import { ApproveContractsComponent } from './pages/approvecontract/approvecontracts.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { DatePipe, registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ViewDesignationComponent } from './components/view-designation/view-designation.component';
import { DesignationsComponent } from './pages/designations/designations.component';
import { UserlistComponent } from './components/userlist/userlist.component';
import { UsersComponent } from './pages/users/users.component';
import { NewuserComponent } from './components/newuser/newuser.component';
import { CreateuserComponent } from './pages/createuser/createuser.component';
import { RolepermsComponent } from './components/roleperms/roleperms.component';
import { ManagerolepermissionComponent } from './pages/managerolepermission/managerolepermission.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { CreateRoleComponent } from './pages/create-role/create-role.component';
import { NewRoleComponent } from './components/new-role/new-role.component';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { EmployeesComponent } from './pages/employees/employees.component';
import { ViewEmployeeComponent } from './components/view-employees/view-employee.component';
import { NewDesignationComponent } from './components/new-designation/new-designation.component';
import { CreateDesignationComponent } from './pages/create-designation/create-designation.component';
import { AprovalconfigComponent } from './components/aprovalconfig/aprovalconfig.component';
import { ApprovallevelsComponent } from './pages/approvallevels/approvallevels.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { VerifyEmployeeComponent } from './components/verify-employee/verify-employee.component';
import { VerifyEmployeeDetailComponent } from './components/verify-employee-detail/verify-employee-detail.component';
import { ViewVerifyEmployeeComponent } from './pages/view-verify-employee/view-verify-employee.component';
import { ViewVerifyEmployeeDetailComponent } from './pages/view-verify-employee-detail/view-verify-employee-detail.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChangepwdComponent } from './components/changepwd/changepwd.component';
import { ChangepasswordComponent } from './pages/changepassword/changepassword.component';
import { ViewExpressApprovalComponent } from './components/view-expressapproval/view-expressapproval.component';
import { ExpressApprovalsComponent } from './pages/expressapproval/expressapprovals.component';
import { GrdFilterPipe } from './pipes/grd-filter.pipe';
import {TableModule} from 'primeng/table';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { UpdateBiometricInfoComponent } from './components/update-biometric-info/update-biometric-info.component';
import { NewExpressApprovalComponent } from './components/new-express-approval/new-express-approval.component';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { EmployeeFileUploadsComponent } from './components/employee-file-uploads/employee-file-uploads.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzFormModule } from 'ng-zorro-antd/form';
import {SplitButtonModule} from 'primeng/splitbutton';
import {ContextMenuModule} from 'primeng/contextmenu';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzInputModule } from 'ng-zorro-antd/input';
import { RequestReportsComponent } from './components/request-reports/request-reports.component';
import { EmployeeReportsComponent } from './components/employee-reports/employee-reports.component';
import { EmpInductionsComponent } from './components/emp-inductions/emp-inductions.component';
import { ViewSafetyinductionComponent } from './pages/view-safetyinduction/view-safetyinduction.component';
import { ViewInductionComponent } from './components/view-induction/view-induction.component';
import { ChangeempComponent } from './components/changeemp/changeemp.component';
//import { ViewSafetyinductionComponent } from './pages/view-safetyinduction/view-safetyinduction.component';
//import { ViewInductionComponent } from './components/view-induction/view-induction.component';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import {CardModule} from 'primeng/card';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { SafetyinductionComponent } from './components/safetyinduction/safetyinduction.component';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import {DialogModule} from 'primeng/dialog';
import {DropdownModule} from 'primeng/dropdown';
import { RequestbydateComponent } from './components/requestbydate/requestbydate.component';
import { ViewRolesComponent } from './components/view-roles/view-roles.component';
import { RolesComponent } from './pages/roles/roles.component';
import { CreateManpowerComponent } from './pages/create-manpower/create-manpower.component';
import { NewManpowerComponent } from './components/new-manpower/new-manpower.component';
import { FirstLogonComponent } from './pages/first-logon/first-logon.component';
import { AccountConfirmationComponent } from './components/accountConfirmation/accountConfirmation.component';
import { ContractsemployeesComponent } from './components/contractsemployees/contractsemployees.component';

import {MultiSelectModule} from 'primeng/multiselect';
import { ApprovemanpowerComponent } from './pages/approvemanpower/approvemanpower.component';
import { ViewApprovemanpowerComponent } from './components/view-approvemanpower/view-approvemanpower.component';
import { ViewManpowerComponent } from './components/view-manpower/view-manpower.component';
import { ApproveComponent } from './pages/approve/approve.component';
import { ManpowerComponent } from './pages/manpower/manpower.component';
import { NewMovementComponent } from './components/new-movement/new-movement.component';
import { CreateMovementComponent } from './pages/create-movement/create-movement.component';
import { ApprovemovementComponent } from './pages/approvemovement/approvemovement.component';
import { ViewApprovemovementComponent } from './components/view-approvemovement/view-approvemovement.component';
import { MovementComponent } from './pages/movement/movement.component';
import { ViewMovementComponent } from './components/view-movement/view-movement.component';
import { ApprovemvtComponent } from './pages/approvemvt/approvemvt.component';
import { ApprovemnpComponent } from './pages/approvemnp/approvemnp.component';
import { ApprovemanpComponent } from './pages/approvemanp/approvemanp.component';
import { MovementReportsComponent } from './components/movement-reports/movement-reports.component';
import { ManpowerReportsComponent } from './components/manpower-reports/manpower-reports.component';
import { ProfileaccountComponent } from './components/profileaccount/profileaccount.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ApprovedmanpowerrequestComponent } from './pages/approvedmanpowerrequest/approvedmanpowerrequest.component';
import { ViewApprovedmanpowerComponent } from './components/view-approvedmanpower/view-approvedmanpower.component';
import { ApprovedmovementrequestComponent } from './pages/approvedmovementrequest/approvedmovementrequest.component';
import { ViewApprovedmovementComponent } from './components/view-approvedmovement/view-approvedmovement.component';
import { ApprovedcontractComponent } from './pages/approvedcontract/approvedcontract.component';
import { ViewApprovedcontractComponent } from './components/view-approvedcontract/view-approvedcontract.component';
import { ManpowerrecruitmentComponent } from './pages/manpowerrecruitment/manpowerrecruitment.component';
import { ManpowerRecruitmentComponent } from './components/manpower-recruitment/manpower-recruitment.component';
import { RecruitmentReportsComponent } from './components/recruitment-reports/recruitment-reports.component';
import { ConfirmtoolsComponent } from './components/confirmtools/confirmtools.component';
import { NewExitclearanceComponent } from './pages/new-exitclearance/new-exitclearance.component';
import { ApproveExitClearanceComponent } from './pages/approve-exit-clearance/approve-exit-clearance.component';
import { AuthorizeExitClearanceComponent } from './pages/authorize-exit-clearance/authorize-exit-clearance.component';
import { ExitClearanceFormsComponent } from './pages/exit-clearance-forms/exit-clearance-forms.component';
import { ExitClearanceReportComponent } from './pages/exit-clearance-report/exit-clearance-report.component';
import { ExitEmployeeUserMgtComponent } from './pages/exit-employee-user-mgt/exit-employee-user-mgt.component';
import { ConfirmClearanceComponent } from './pages/confirm-clearance/confirm-clearance.component';
import { ManpowerDraftsComponent } from './components/manpower-drafts/manpower-drafts.component';
import { EditManpowerDraftComponent } from './components/edit-manpower-draft/edit-manpower-draft.component';
import { NewAdhocComponent } from './components/new-adhoc/new-adhoc.component';
import { ViewApproveadhocComponent } from './components/view-approveadhoc/view-approveadhoc.component';
import { ViewAdhocComponent } from './components/view-adhoc/view-adhoc.component';
import { ViewAxiomComponent } from './components/view-axiom/view-axiom.component';
import { NewAxiomComponent } from './components/new-axiom/new-axiom.component';
import { NewJobRotationComponent } from './components/new-job-rotation/new-job-rotation.component';
import { ViewJobRotationsComponent } from './components/view-job-rotations/view-job-rotations.component';
import { ApproveJobRotationComponent } from './components/approve-job-rotation/approve-job-rotation.component';
import { AdhocRequestReportsComponent } from './components/request-reports/adhoc-request-reports/adhoc-request-reports.component';
import { AllContractsComponent } from './pages/allcontracts/all-contracts/all-contracts.component';
import { ViewAllContractsComponent } from './components/viewallcontracts/view-all-contracts/view-all-contracts.component';
import { NewhireonboardingComponent } from './components/newhireonboarding/newhireonboarding.component';
import { DocumentationNewHireComponent } from './components/documentation-new-hire/documentation-new-hire.component';
import { NewHiresViewComponent } from './components/new-hires-view/new-hires-view.component';
//import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
//import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
//import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
//import { ApproveComponent } from './pages/approve/approve.component';


 

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    AppLayoutComponent,
    AccessComponent,
    SigninComponent,
    DashComponent,
    HomeComponent,
    SidemenusComponent,
    HomeMainComponent,
    TopBarComponent,
    RightSidebarComponent,

    NewContractComponent,
    CreateContractComponent,
    ViewContractComponent,
    ContractsComponent,
    ViewApproveContractComponent,
    ApproveContractsComponent,
    ViewExpressApprovalComponent,
    ExpressApprovalsComponent,

    NewEmployeeComponent,
    CreateEmployeeComponent,
    ViewEmployeeComponent,
    EmployeesComponent,

    NewSkillComponent,
    CreateSkillComponent,
    ViewSkillComponent,
    SkillsComponent,

    NewVendorComponent,
    CreateVendorComponent,
    ViewVendorComponent,
    VendorsComponent,

    NewCostCenterComponent,
    CreateCostCenterComponent,
    ViewCostCenterComponent,
    CostCentersComponent,

    NewLocationComponent,
    CreateLocationComponent,
    ViewLocationComponent,
    LocationsComponent,

    NewDesignationComponent,
    CreateDesignationComponent,
    ViewDesignationComponent,
    DesignationsComponent,

    UserlistComponent,
    UsersComponent,
    NewuserComponent,
    CreateuserComponent,

    RolepermsComponent,
    ManagerolepermissionComponent,
    NewRoleComponent,
    CreateRoleComponent,
    AprovalconfigComponent,
    ApprovallevelsComponent,

    FileUploadComponent,
    
    VerifyEmployeeComponent,
    VerifyEmployeeDetailComponent,
    ViewVerifyEmployeeComponent,
    ViewVerifyEmployeeDetailComponent,
    ChangepwdComponent,
    ChangepasswordComponent,
    GrdFilterPipe,
    UpdateBiometricInfoComponent,
    NewExpressApprovalComponent,
    EmployeeFileUploadsComponent,
    RequestReportsComponent,
    EmployeeReportsComponent,
    EmpInductionsComponent,
    ViewInductionComponent,
    ViewSafetyinductionComponent,
    ChangeempComponent,
    SafetyinductionComponent,
    RequestbydateComponent,
    ViewRolesComponent,
    RolesComponent,
    CreateManpowerComponent,
    NewManpowerComponent,
    FirstLogonComponent,
    AccountConfirmationComponent,
    ContractsemployeesComponent,
    ApprovemanpowerComponent,
    ViewApprovemanpowerComponent,
    ViewManpowerComponent,
    ApproveComponent,
    ManpowerComponent,
    NewMovementComponent,
    CreateMovementComponent,
    ApprovemovementComponent,
    ViewApprovemovementComponent,
    MovementComponent,
    ViewMovementComponent,
    ApprovemvtComponent,
    ApprovemnpComponent,
    ApprovemanpComponent,
    MovementReportsComponent,
    ManpowerReportsComponent,
    ProfileaccountComponent,
    ProfileComponent,
    ApprovedmanpowerrequestComponent,
    ViewApprovedmanpowerComponent,
    ApprovedmovementrequestComponent,
    ViewApprovedmovementComponent,
    ApprovedcontractComponent,
    ViewApprovedcontractComponent,
    ManpowerrecruitmentComponent,
    ManpowerRecruitmentComponent,
    RecruitmentReportsComponent,
  
    ConfirmtoolsComponent,
        NewExitclearanceComponent,
        ApproveExitClearanceComponent,
        AuthorizeExitClearanceComponent,
        ExitClearanceFormsComponent,
        ExitClearanceReportComponent,
        ExitEmployeeUserMgtComponent,
        ConfirmClearanceComponent,
        ManpowerDraftsComponent,
        EditManpowerDraftComponent,
        NewAdhocComponent,
        ViewApproveadhocComponent,
        ViewAdhocComponent,
        ViewAxiomComponent,
        NewAxiomComponent,
        NewJobRotationComponent,
        ViewJobRotationsComponent,
        ApproveJobRotationComponent,
        AdhocRequestReportsComponent,
        AllContractsComponent,
        ViewAllContractsComponent,
        NewhireonboardingComponent,
        DocumentationNewHireComponent,
        NewHiresViewComponent,

 
  ],
  imports: [
    BrowserModule, 
    AppRoutingModule,
    HttpClientModule, NzTreeModule ,CardModule,NzMessageModule ,NzSpaceModule ,DropdownModule,
    NgSelectModule, NzDropDownModule ,NzListModule ,NzRadioModule ,
    FormsModule, NzAlertModule , NzModalModule ,  NzFormModule , SplitButtonModule,NzInputModule  ,NzSkeletonModule,
    ReactiveFormsModule, NzSelectModule , NzPopconfirmModule ,NzCardModule ,NzUploadModule , ContextMenuModule,
    ToastrModule.forRoot(),    NzTableModule  ,NzDrawerModule , NzNotificationModule,NzDatePickerModule ,
    LoadingBarHttpClientModule,LoadingBarRouterModule, BrowserAnimationsModule, NzButtonModule, NgbModule,
    TableModule, DialogModule, MultiSelectModule, NzCheckboxModule,
    TableModule, DialogModule, MultiSelectModule,  //NgxExtendedPdfViewerModule 
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule
    
  ],
  providers: [AuthInterceptorProvider, { provide: NZ_I18N, useValue: en_US },DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
